/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Ai_Stage_DiscoverInputs */

const en_directory_detail_signals_ai_stage_discover = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover`)
};

const zh_directory_detail_signals_ai_stage_discover = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现`)
};

/**
* | output |
* | --- |
* | "Discover" |
*
* @param {Directory_Detail_Signals_Ai_Stage_DiscoverInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_ai_stage_discover = /** @type {((inputs?: Directory_Detail_Signals_Ai_Stage_DiscoverInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Ai_Stage_DiscoverInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_ai_stage_discover(inputs)
	return zh_directory_detail_signals_ai_stage_discover(inputs)
});
export { directory_detail_signals_ai_stage_discover as "directory.detail.signals.ai_stage.discover" }